import { Component, ViewChild, OnInit,ViewEncapsulation } from '@angular/core';
import { NgForm, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

// import custom validator to validate that password and confirm password fields match
import { MustMatch } from '../../../shared/directives/must-match.validator';
import { Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { data } from 'app/shared/data/smart-data-table';
import { ToastrService } from 'ngx-toastr';




@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.scss' , '../../../../assets/sass/libs/select.scss'],
  encapsulation: ViewEncapsulation.None
})

export class RegisterPageComponent implements OnInit {
  @ViewChild('vform') validationForm: FormGroup;

  registerFormSubmitted = false;
  selectedTag:any=[];
  selectedCategory=''
  roles=[];
  courseList=[];
  categoryList=[];
  tagsList=[];
  selectedValue:any=[];
  isAdmin:boolean=false
  isManager:boolean=false
  isStudent:boolean=false
  registerForm: FormGroup;
  fileData:File;
  selectedBatch='';
  batchList=[];
  

  
  constructor(private formBuilder: FormBuilder, private router: Router,
    private apiService:ApiService,public toastr: ToastrService) { 
      this.getCategoryList()
      this.getTagList()
    }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required,Validators.minLength(10),Validators.maxLength(10)]],
      // college: ['', Validators.required],
      last_qualification: ['', Validators.required],
      course: ['', Validators.required],
      coursecatinterest_id: ['', Validators.required],
      skillsinterest_id:[''],

      // name: ['', Validators.required],
      // headshot: ['', Validators.required],
      // email: ['', [Validators.required, Validators.email]],
      // password: ['', [Validators.required,Validators.minLength(4)]],
      // confirmPassword: ['', Validators.required],
      // phone : ['', [Validators.required,Validators.minLength(10),Validators.maxLength(10)]],
      // roles: ['62a6eec5da93b1750e502ce6', Validators.required],
      // linked_in: ['', Validators.required],
      // dob: ['', Validators.required],
      // sex: ['',Validators.required],
      // address: ['', Validators.required],
      // location: ['', Validators.required],
      // notes: ['', Validators.required],
      // admin_notes: ['', Validators.required],
// -------- Student -------------------------
      // bio: ['', Validators.required],
      // badges: ['', Validators.required],
      // goal: ['',Validators.required],
      // mode: ['', Validators.required],
      // hunting_by: ['', Validators.required],
      // farming_by: ['', Validators.required],
      // team: ['', Validators.required],
      // project_ids: ['', Validators.required],
      // placementInfo: ['', Validators.required],
      // overview: ['',Validators.required],
      // college_id: ['', Validators.required],
      // last_qualificaiton: ['', Validators.required],
      // instrested_courses: ['', Validators.required],
     
    }, {
      // validator: MustMatch('password', 'confirmPassword')
    });
  }

  get rf() {
    return this.registerForm.controls;
  }
  // getBatchList(){
  //   this.apiService.getBatchList(1,100).subscribe((res:any)=>{
  //     console.log(res)
  //     this.batchList=res.data.items 
  //   })
  //  }
  //  getBatchId(event:any){
  //   console.log('batch',this.selectedBatch)
  //  }
  //  On submit click, reset field value
  onSubmit() {
    // let formData=new FormData();
    // for (let item of this.selectedValue){
    //   console.log(item)
    //   formData.append('course[]', item)
    // }
    // formData.append('name', this.registerForm.controls.name.value),
    // formData.append('role', this.registerForm.controls.role.value),
    // formData.append('email', this.registerForm.controls.email.value),
    // formData.append('college', this.registerForm.controls.college.value),
    // formData.append('dob', this.registerForm.controls.dob.value),
    // formData.append('gender', this.selectValue),
    // // formData.append('course', this.selectedValue),
    // formData.append('phoneNumber', this.registerForm.controls.phoneNumber.value),
    // formData.append('lastQualification', this.registerForm.controls.lastQualification.value),
    // formData.append('password', this.registerForm.controls.password.value),
    // formData.append('image', this.fileData ),
    
    let body={
      name:this.registerForm.controls.name.value,
      email:this.registerForm.controls.email.value,
      phone:this.registerForm.controls.phone.value,
      // college:this.registerForm.controls.college.value,
      last_qualification:this.registerForm.controls.last_qualification.value,
      coursecatinterest_id:this.selectedCategory,
      skillsinterest_id:[this.selectedTag]
    }
    this.registerFormSubmitted = true
    if(this.registerForm.controls.email.valid && this.registerForm.controls.phone.valid){
      this.apiService.createEnrolment(body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          console.log('enrolment',res)    
          this.toastr.success(res.message)  
          this.router.navigate(['/thanks-for-register']);
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    else{
    this.toastr.error('please fill required fields!')
    }
    
  }

// getCourseList(){
//   this.apiService.getCourseList(1,100).subscribe((res:any)=>{
//     console.log(res)
//     this.courseList=res.data.items
//   })
//  }
 getCategoryList(){
  this.apiService.getAllCategory(1,100).subscribe((res:any)=>{
    console.log('category list res',res)
    this.categoryList=res.data.items
  })
 }
 getCategoryId(event:any){
  console.log('select Category val => ',this.selectedCategory)
 }
getTagList(){
  this.apiService.getTagsList(1,100).subscribe((res:any)=>{
    console.log('tags list res',res)
    this.tagsList=res.data.items
  })
}
getTagsId(event:any){
  console.log('selected tag',this.selectedTag)
}
//  getCourseId(event:any){
//   this.selectedValue=event.target.value
//   console.log('course',this.selectedValue)
//  }
  // onSelectFile(event:any){
  //   if (event.target.files && event.target.files[0]) {
  //     var reader = new FileReader();
  //     this.fileData = event.target.files[0];
  //     console.log('event',this.fileData)
  //     reader.readAsDataURL(event.target.files[0]);
  //   }
  // }
  // changeGender(event): void{
  //   this.selectValue=event.target.value
  //   console.log('gender',this.selectValue)
  //  }
  

  
}
